import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

interface IProps {
  visible: boolean;
  loading: boolean;
  pendingSubmitData: any;
  originalRates: { bRate: any; sRate: any; mRate: any };
  onConfirm: () => void;
  onCancel: () => void;
}

export const RateChangeDialog = ({ visible, loading, pendingSubmitData, originalRates, onConfirm, onCancel }: IProps) => {
  return (
    <Dialog
      visible={visible}
      onHide={onCancel}
      header="Confirm Rate Change"
      style={{ width: "30rem" }}
      modal
      footer={
        <div className="flex justify-content-end gap-2">
          <Button label="No, Cancel" icon="pi pi-times" className="p-button-outlined p-button-sm" onClick={onCancel} />
          <Button label="Yes, Proceed" icon="pi pi-check" className="p-button-sm p-button-warning" onClick={onConfirm} loading={loading} />
        </div>
      }
    >
      <div className="flex align-items-center gap-3 py-2">
        <i className="pi pi-exclamation-triangle text-4xl" style={{ color: "#f59e0b" }} />
        <div>
          <p className="m-0 font-semibold" style={{ color: "red" }}>
            Are you sure you want to change the PO rates?
          </p>
          <p className="m-0 mt-4 text-800 text-base">
            Changes to <strong>Buying Rate</strong>, <strong>Submission Rate</strong>, or <strong>Margin</strong> will only be reflected after approval by <strong>Admin</strong>.
          </p>
          {pendingSubmitData && (
            <div className="mt-4 text-sm">
              {pendingSubmitData.bRate !== originalRates.bRate && (
                <p className="m-0" style={{ color: "black" }}>
                  Buying Rate: <span style={{ color: "red" }}>{originalRates.bRate}</span> → <span className="text-green-500">{pendingSubmitData.bRate}</span>
                </p>
              )}
              {pendingSubmitData.sRate !== originalRates.sRate && (
                <p className="m-0" style={{ color: "black" }}>
                  Submission Rate: <span style={{ color: "red" }}>{originalRates.sRate}</span> → <span className="text-green-500">{pendingSubmitData.sRate}</span>
                </p>
              )}
              {pendingSubmitData.mRate !== originalRates.mRate && (
                <p className="m-0" style={{ color: "black" }}>
                  Margin: <span style={{ color: "red" }}>{originalRates.mRate}</span> → <span className="text-green-500">{pendingSubmitData.mRate}</span>
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};
